import {sendBroadcast} from '../utils';

/**
 * 重置游戏（原理就是发送消息__restart__，游戏块中写好接受到消息__restart__就将游戏恢复到开始状态）
 * TODO 应当再触发stop和start，因为常规的游戏都是通过停止和开始来重置的
 * @returns {promise} Promise
 */
export default function restart () {
    return new Promise(resolve => {
        sendBroadcast('__restart__');
        setTimeout(() => {
            resolve(true);
        }, 200);
    });
}
